/**
 * Mock Data for Staff Charts and Tables
 *
 * Contains mock data used in various staff-related chart and table components
 */

import { HorizontalBarChartData } from '../Common/HorizontalBarChart.tsx/HorizontalBarChart';

// Data structure for service duration
export interface ServiceDuration {
    ranking: number;
    name: string;
    duration: string;
    sessions: number;
}

// Mock data for total appointments per staff chart
// Total current: 1169, Total previous: 1002
export const staffAppointmentsData: HorizontalBarChartData[] = [
    {
        name: 'John Doe',
        currentValue: 58,
        previousValue: 51,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 5, // 58/1169 * 100 ≈ 5%
        previousShare: 5 // 51/1002 * 100 ≈ 5%
    },
    {
        name: 'Ana Doe',
        currentValue: 123,
        previousValue: 91,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 11, // 123/1169 * 100 ≈ 11%
        previousShare: 9 // 91/1002 * 100 ≈ 9%
    },
    {
        name: 'Luis Doe',
        currentValue: 108,
        previousValue: 91,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 9, // 108/1169 * 100 ≈ 9%
        previousShare: 9 // 91/1002 * 100 ≈ 9%
    },
    {
        name: 'Maria Doe',
        currentValue: 86,
        previousValue: 51,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 7, // 86/1169 * 100 ≈ 7%
        previousShare: 5 // 51/1002 * 100 ≈ 5%
    },
    {
        name: 'Max Doe',
        currentValue: 59,
        previousValue: 107,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 5, // 59/1169 * 100 ≈ 5%
        previousShare: 11 // 107/1002 * 100 ≈ 11%
    },
    {
        name: 'Alex Doe',
        currentValue: 40,
        previousValue: 25,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 3, // 40/1169 * 100 ≈ 3%
        previousShare: 2 // 25/1002 * 100 ≈ 2%
    },
    {
        name: 'Mary Doe',
        currentValue: 109,
        previousValue: 81,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 9, // 109/1169 * 100 ≈ 9%
        previousShare: 8 // 81/1002 * 100 ≈ 8%
    },
    {
        name: 'James Doe',
        currentValue: 25,
        previousValue: 38,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 2, // 25/1169 * 100 ≈ 2%
        previousShare: 4 // 38/1002 * 100 ≈ 4%
    },
    {
        name: 'Emma Doe',
        currentValue: 38,
        previousValue: 115,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 3, // 38/1169 * 100 ≈ 3%
        previousShare: 11 // 115/1002 * 100 ≈ 11%
    },
    {
        name: 'Oliver Doe',
        currentValue: 109,
        previousValue: 99,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 9, // 109/1169 * 100 ≈ 9%
        previousShare: 10 // 99/1002 * 100 ≈ 10%
    },
    {
        name: 'Sophia Doe',
        currentValue: 62,
        previousValue: 65,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 5, // 62/1169 * 100 ≈ 5%
        previousShare: 6 // 65/1002 * 100 ≈ 6%
    },
    {
        name: 'Ethan Doe',
        currentValue: 121,
        previousValue: 51,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 10, // 121/1169 * 100 ≈ 10%
        previousShare: 5 // 51/1002 * 100 ≈ 5%
    },
    {
        name: 'Isabella Doe',
        currentValue: 133,
        previousValue: 51,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 11, // 133/1169 * 100 ≈ 11%
        previousShare: 5 // 51/1002 * 100 ≈ 5%
    },
    {
        name: 'Noah Doe',
        currentValue: 19,
        previousValue: 35,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 2, // 19/1169 * 100 ≈ 2%
        previousShare: 3 // 35/1002 * 100 ≈ 3%
    },
    {
        name: 'Ava Doe',
        currentValue: 79,
        previousValue: 51,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024',
        currentShare: 7, // 79/1169 * 100 ≈ 7%
        previousShare: 5 // 51/1002 * 100 ≈ 5%
    }
];

// Mock data for tips distribution chart
export const tipsDistributionData: HorizontalBarChartData[] = [
    {
        name: 'John Doe',
        currentValue: 1415,
        previousValue: 1286,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Ana Doe',
        currentValue: 1210,
        previousValue: 1080,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Luis Doe',
        currentValue: 1072,
        previousValue: 1128,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Maria Doe',
        currentValue: 896,
        previousValue: 853,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Max Doe',
        currentValue: 613,
        previousValue: 613,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Alex Doe',
        currentValue: 342,
        previousValue: 380,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    },
    {
        name: 'Mary Doe',
        currentValue: 298,
        previousValue: 271,
        currentDate: 'Jan 1-Sep 18, 2025',
        previousDate: 'Jan 1-Sep 18, 2024'
    }
];

// Mock data for service duration table
export const serviceDurationData: ServiceDuration[] = [
    { ranking: 1, name: 'Full Grooming', duration: '2h 15m', sessions: 320 },
    { ranking: 2, name: 'Bath & Brush', duration: '1h 5m', sessions: 415 },
    { ranking: 3, name: 'Nail Trimming', duration: '25m', sessions: 180 },
    { ranking: 4, name: 'Ear Cleaning', duration: '15m', sessions: 220 },
    { ranking: 5, name: 'Haircut Only', duration: '1h 40m', sessions: 150 },
    { ranking: 6, name: 'Teeth Cleaning', duration: '35m', sessions: 90 }
];
